var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videopreview-wrapper"},[_c('video',{staticClass:"videopreview-video-element",attrs:{"oncontextmenu":"return false;","disablePictureInPicture":"","controls":"","autoplay":"","controlsList":"nodownload","name":"media"}},[_c('source',{attrs:{"src":_vm.fileUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }